'use client'

import { useEffect, useState } from "react";
import React, { JSX } from "react";
import IconText from "../../components/icon-text"
import IconLocationViolet from "../../components/svg/locationViolet"
import IconFlagViolet from "../../components/svg/flagViolet"
import IconBoxViolet from "../../components/svg/boxViolet"
import IconAbroadViolet from "../../components/svg/abroadViolet"

interface HeroProps {
    title: string; 
    list: Array<{
        text: string;
        icon: string;
    }>
}

const getIconComponent = (iconName: string) => {
    const icons: { [key: string]: JSX.Element } = {
        LocationViolet: <IconLocationViolet />,
        BoxViolet: <IconBoxViolet />,
        AbroadViolet: <IconAbroadViolet />,
        FlagViolet: <IconFlagViolet />,
    };

    return icons[iconName] || null;
};

const Hero: React.FC<HeroProps> = ({ title, list }) => {
    const [bgImage, setBgImage] = useState("/bg/hero.png");

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 992) {
                setBgImage("/bg/hero-mob.png");
            } else {
                setBgImage("/bg/hero.png");
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section 
            className="pt-[128px] pb-44 bg-no-repeat bg-right bg-bottom 
            max-[992px]:bg-[length:328px] 
            max-[992px]:bg-right-top 
            max-[992px]:pt-[238px]
            max-[992px]:pb-[56px]
            "
            style={{ backgroundImage: `url('${bgImage}')` }}
        >
            <div className="container">
                <div className="max-w-[672px]">
                    <h1 className="font-bold text-[64px] leading-[137%] text-black max-[1200px]:text-[32px]" dangerouslySetInnerHTML={{ __html: title }}/>
                    <div className="mt-[52px] flex flex-col gap-y-4">
                        {list.map((item, index) => (
                            <IconText key={index} text={item.text} icon={getIconComponent(item.icon)} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;